import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class OtherliabilitiesandaccrualsSoletraderService {

  URl = this.ConfigService.getAPIBaseUrl() + 'api/OtherliabilitiesandaccrualsSoletrader'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  insertdetails(data: any) {
    return this.http.post(this.URl + '/InsertOtherliabilitiesandaccrualsSoletrader', data)
  }
  getdata(APPeriodId: any) {
    return this.http.get(this.URl + '/GetOtherliabilitiesandaccrualsSoletrader?APPeriodId=' + APPeriodId)
  }
  getdata_LY(APPeriodId: any) {
    return this.http.get(this.URl + '/GetOtherliabilitiesandaccrualsSoletrader_LY?APPeriodId=' + APPeriodId)
  }
} 
